// Comprehensive international timezone list grouped by region
export const TIMEZONES = [
  // ── Americas ──────────────────────────────────────────────
  { value: "Pacific/Samoa", label: "Samoa (UTC−11)" },
  { value: "Pacific/Honolulu", label: "Hawaii (UTC−10)" },
  { value: "America/Anchorage", label: "Alaska (UTC−9)" },
  { value: "America/Los_Angeles", label: "Pacific Time — US & Canada (UTC−8/−7)" },
  { value: "America/Phoenix", label: "Arizona (UTC−7, no DST)" },
  { value: "America/Denver", label: "Mountain Time — US & Canada (UTC−7/−6)" },
  { value: "America/Chicago", label: "Central Time — US & Canada (UTC−6/−5)" },
  { value: "America/New_York", label: "Eastern Time — US & Canada (UTC−5/−4)" },
  { value: "America/Halifax", label: "Halifax / Atlantic Time (UTC−4/−3)" },
  { value: "America/St_Johns", label: "Newfoundland (UTC−3:30/−2:30)" },
  { value: "America/Sao_Paulo", label: "São Paulo / Brasília (UTC−3)" },
  { value: "America/Argentina/Buenos_Aires", label: "Buenos Aires (UTC−3)" },
  { value: "America/Santiago", label: "Santiago (UTC−4/−3)" },
  { value: "America/Caracas", label: "Caracas (UTC−4)" },
  { value: "America/Bogota", label: "Bogotá / Lima / Quito (UTC−5)" },
  { value: "America/Mexico_City", label: "Mexico City (UTC−6/−5)" },
  { value: "America/Winnipeg", label: "Winnipeg / Central Canada (UTC−6/−5)" },
  { value: "America/Vancouver", label: "Vancouver / Pacific Canada (UTC−8/−7)" },
  { value: "America/Toronto", label: "Toronto / Eastern Canada (UTC−5/−4)" },

  // ── Europe ────────────────────────────────────────────────
  { value: "Atlantic/Azores", label: "Azores (UTC−1/0)" },
  { value: "Europe/Lisbon", label: "Lisbon / Reykjavik (UTC+0/+1)" },
  { value: "Europe/London", label: "London / Dublin / Edinburgh (UTC+0/+1)" },
  { value: "Europe/Amsterdam", label: "Amsterdam / Berlin / Paris / Rome / Madrid (UTC+1/+2)" },
  { value: "Europe/Athens", label: "Athens / Helsinki / Kyiv / Bucharest (UTC+2/+3)" },
  { value: "Europe/Moscow", label: "Moscow / St. Petersburg (UTC+3)" },
  { value: "Europe/Istanbul", label: "Istanbul (UTC+3)" },

  // ── Africa ────────────────────────────────────────────────
  { value: "Africa/Abidjan", label: "Abidjan / Accra / Dakar (UTC+0)" },
  { value: "Africa/Lagos", label: "Lagos / Kinshasa / Algiers (UTC+1)" },
  { value: "Africa/Cairo", label: "Cairo (UTC+2)" },
  { value: "Africa/Nairobi", label: "Nairobi / Addis Ababa (UTC+3)" },
  { value: "Africa/Johannesburg", label: "Johannesburg / Harare (UTC+2)" },

  // ── Middle East ───────────────────────────────────────────
  { value: "Asia/Tehran", label: "Tehran (UTC+3:30/+4:30)" },
  { value: "Asia/Dubai", label: "Dubai / Abu Dhabi / Muscat (UTC+4)" },
  { value: "Asia/Kabul", label: "Kabul (UTC+4:30)" },
  { value: "Asia/Riyadh", label: "Riyadh / Kuwait / Baghdad (UTC+3)" },
  { value: "Asia/Jerusalem", label: "Jerusalem / Tel Aviv (UTC+2/+3)" },

  // ── Asia ──────────────────────────────────────────────────
  { value: "Asia/Karachi", label: "Karachi / Tashkent (UTC+5)" },
  { value: "Asia/Kolkata", label: "Kolkata / Mumbai / New Delhi (UTC+5:30)" },
  { value: "Asia/Kathmandu", label: "Kathmandu (UTC+5:45)" },
  { value: "Asia/Dhaka", label: "Dhaka / Almaty (UTC+6)" },
  { value: "Asia/Rangoon", label: "Yangon / Rangoon (UTC+6:30)" },
  { value: "Asia/Bangkok", label: "Bangkok / Jakarta / Hanoi (UTC+7)" },
  { value: "Asia/Singapore", label: "Singapore / Kuala Lumpur / Hong Kong (UTC+8)" },
  { value: "Asia/Shanghai", label: "Beijing / Shanghai / Taipei (UTC+8)" },
  { value: "Asia/Seoul", label: "Seoul (UTC+9)" },
  { value: "Asia/Tokyo", label: "Tokyo / Osaka / Sapporo (UTC+9)" },

  // ── Pacific ───────────────────────────────────────────────
  { value: "Australia/Darwin", label: "Darwin (UTC+9:30, no DST)" },
  { value: "Australia/Perth", label: "Perth (UTC+8)" },
  { value: "Australia/Brisbane", label: "Brisbane / Queensland (UTC+10, no DST)" },
  { value: "Australia/Adelaide", label: "Adelaide (UTC+9:30/+10:30)" },
  { value: "Australia/Sydney", label: "Sydney / Melbourne / Canberra (UTC+10/+11)" },
  { value: "Pacific/Auckland", label: "Auckland / Wellington (UTC+12/+13)" },
  { value: "Pacific/Fiji", label: "Fiji (UTC+12)" },

  // ── Universal ─────────────────────────────────────────────
  { value: "UTC", label: "UTC — Coordinated Universal Time" },
];

/**
 * Get the browser's detected timezone using the Intl API.
 * Falls back to "UTC" if detection fails.
 */
export function getDeviceTimezone(): string {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
  } catch {
    return "UTC";
  }
}

/**
 * Get a friendly label for a timezone identifier.
 * Falls back to formatting the identifier if not found in the list.
 */
export function getTimezoneLabel(timezone: string): string {
  const found = TIMEZONES.find(tz => tz.value === timezone);
  if (found) return found.label;

  // Format unknown timezones nicely (e.g., "America/New_York" -> "America / New York")
  return timezone.replace(/_/g, " ").replace(/\//g, " / ");
}
